import React from "react";
import { Helmet } from "react-helmet";
import ContactBody from "../components/contact/ContactBody";
import PageHero from "../components/reusables/hero/PageHero";

export default function Contact() {
  return (
    <>
      <Helmet>
        <link
          rel="conanical"
          href="https://www.nexuseventsug.com/contact"
        />
        <meta
          name="description"
          content="NEXUS EVENTS UGANDA is Uganda's leading events planner and production company."
        />
        <meta
          property="og:description"
          content="NEXUS EVENTS UGANDA is Uganda's leading events planner and production company."
        />
        <meta
          property="og:title"
          content="Contact Us - NEXUS EVENTS UGANDA"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1741660851/nexusbanner_no0spp.jpg"
        />

        <meta
          name="twitter:title"
          content="Contact Us - NEXUS EVENTS UGANDA"
        />
        <meta
          name="twitter:text:title"
          content="Contact Us - NEXUS EVENTS UGANDA"
        />
        <meta
          name="twitter:description"
          content="NEXUS EVENTS UGANDA is Uganda's leading events planner and production company."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1741660851/nexusbanner_no0spp.jpg"
        />
        <title>Contact Us - NEXUS EVENTS UGANDA</title>
      </Helmet>
      <PageHero
        classes="event-bg"
        titleClasses="title uppercase white"
        title="Contact Us"
      />
      <ContactBody />
    </>
  );
}
